<template>
  <div>
    <van-swipe :autoplay="3000" style="height: 5.3125rem;white:20.94rem" @change="swipeChange" >
      <van-swipe-item v-for="(image, index) in imagesList" :key="index" >
        <img v-lazy="image.url" @click="goToUrl" :id="image.id" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  props: ["images"],
  data(){
    return {
      imagesList:[]
    }
  },
  methods:{
    swipeChange(index){
      console.log(index)
    },
    goToUrl(e){
      for (const key in this.images) {
        if(this.images[key].advertis.id == e.target.id){
          window.location.href = this.images[key].advertis.plink
          break
        }
      }
    }
  },
  watch:{
    images:{
      deep:true,
      immediate:true,
      handler(val){
        val.forEach(item => {
          if(item.advertis == null) return false
          this.imagesList.push({url:item.advertis.url,id:item.advertis.id})
        })
      }
    }
  }
};
</script>

<style scoped lang="less"></style>
